import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { Badge } from '../ui/badge';

const WishlistIcon = ({ count = 0, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="relative p-2 hover:bg-muted rounded-full transition-colors"
      aria-label="Lista de deseos"
    >
      <Heart className="w-5 h-5" />
      {count > 0 && (
        <motion.span
          key={count}
          initial={{ scale: 0 }}
          animate={{ 
            scale: [0, 1.3, 1],
            transition: { duration: 0.3 }
          }}
          className="absolute -top-1 -right-1 bg-destructive text-destructive-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium"
        >
          {count}
        </motion.span>
      )}
    </button>
  );
};

export default WishlistIcon;